<template>
  <div>
    <div id="app" v-if="!phone">
      <router-view/>
    </div>
    <div id="phone" v-if="phone">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      phone: false
    }
  },
  created () {
    this.phone = this.isMobile()
    this.setWidth()
    this.appRouter()
  },
  mounted () {
    window.onresize = () => {
      this.phone = this.isMobile()
      this.setWidth()
      this.appRouter()
    }
  },
  methods: {
    isMobile () {
      let width = window.innerWidth
      if (width < 860) {
        return true
      }
      const ua = navigator.userAgent
      const isPhone = /mobile/i.test(ua)
      if (!isPhone) {
        return false
      }
      const isAndroid = /(?:Android)/.test(ua)
      const isFireFox = /(?:Firefox)/.test(ua)
      const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
        /(?:Tablet)/.test(ua))
      return !isTablet
    },
    appRouter () {
      let router = this.getRouter()
      const first = router[0]
      router = '/' + router.join('/')
      if (this.phone && first !== 'phone') {
        this.$router.push('/phone' + router).catch(err => {
          console.log(err)
        })
      } else if (!this.phone && first === 'phone') {
        this.$router.push(router.replace('/phone', '')).catch(err => {
          console.log(err)
        })
      }
    },
    getRouter () {
      let router = window.location.href
      router = router.replace('http://', '').replace('https://', '')
      let arr = router.split('/')
      arr.splice(0, 1)
      return arr
    },
    setWidth () {
      const max = 860
      this.$store.dispatch('app/getFooter').then(() => {}).catch(() => {})
      let width = window.innerWidth > max ? window.innerWidth : max
      this.$store.dispatch('app/setWidth', width)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue